import JsonView from "@uiw/react-json-view";
import { Button, Modal } from "antd";
import { useEffect, useState } from "react";

const SuccessModal = ({ title, text, modalOpen, onModalClose }) => {
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [parsedData, setParsedData] = useState(null);
  const [isJson, setIsJson] = useState(false);

  useEffect(() => {
    setSuccessModalOpen(modalOpen);

    // Check if text is valid JSON
    try {
      const jsonData = JSON.parse(text);
      if (typeof jsonData === "object" && jsonData !== null) {
        setParsedData(jsonData);
        setIsJson(true);
      } else {
        setParsedData(text);
        setIsJson(false);
      }
    } catch (error) {
      // If parsing fails, treat as plain text
      setParsedData(text);
      setIsJson(false);
    }
  }, [modalOpen, text]);

  return (
    <Modal
      title={<div className="text-2xl">{title}</div>}
      centered
      open={successModalOpen}
      footer={[
        <div className="flex items-center justify-end gap-3" key="footer">
          <Button
            htmlType="button"
            type="primary"
            onClick={() => {
              setSuccessModalOpen(false);
              onModalClose();
            }}
          >
            Okay
          </Button>
        </div>,
      ]}
      onOk={() => {
        setSuccessModalOpen(false);
        onModalClose();
      }}
      onCancel={() => {
        setSuccessModalOpen(false);
        onModalClose();
      }}
    >
      <div className="py-8 text-sm border-b border-gray-300 w-full">
        <div className="w-full mb-6">
          {isJson ? (
            <JsonView value={parsedData} />
          ) : (
            <div className="whitespace-pre-wrap break-words">{parsedData}</div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default SuccessModal;
